<template>
    <main>
        <!-- breadcrumb area start here -->
        <section class="bd-breadcrumb-area p-relative fix theme-bg">
            <!-- breadcrumb background image -->
            <div class="bd-breadcrumb-bg" :style="{ backgroundImage: 'url(/img/bg/breadcrumb-bg.jpg)' }"></div>
            <div class="bd-breadcrumb-wrapper mb-60 p-relative">
                <div class="container">
                    <div class="row justify-content-center">
                        <div class="col-xl-10">
                            <div class="bd-breadcrumb d-flex align-items-center justify-content-center">
                                <div class="bd-breadcrumb-content text-center">
                                    <h1 class="bd-breadcrumb-title">Principal's Message</h1>
                                    <div class="bd-breadcrumb-list">
                                        <span><a href="/"><i class="flaticon-hut"></i>Home</a></span>
                                        <div class="bd-breadcrumb-list">
                                            <span><a href="#">About</a></span>
                                        </div>
                                        <span>Principal's Message</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="bd-wave-wrapper bd-wave-wrapper-3">
                <div class="bd-wave bd-wave-3"></div>
                <div class="bd-wave bd-wave-3"></div>
            </div>
        </section>
        <!-- breadcrumb area end here  -->

        <!-- teacher details widget start here-->
        <section class="bd-teacher-widget-area pb-0 pt-120">
            <div class="container">
                <div class="row">
                    <div class="col-lg-6 mb-50">
                        <div class="bd-teacher-widget wow fadeInLeft" data-wow-duration="1s" data-wow-delay=".3s">
                            <div class="bd-teacher-widget-thumb p-relative">
                                <img src="/img/general/principal.jpg" alt="img not found!" style="height: 478px;">
                                <div class="panel wow"></div>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-6 mb-50">
                        <div class="bd-teacher-widget theme-bg-6 wow fadeInRight" data-wow-duration="1s"
                            data-wow-delay=".3s">
                            <div class="bd-teacher-widget-content">
                                <h3 class="bd-teacher-widget-title">Yogesh Kuman Sharma</h3>
                                <span class="bd-teacher-widget-tag">Principal, Baburam Vedanta School</span>
                                <p>At Baburam Vedanta School, Bharatpur, we believe that every child deserves quality education and equal opportunities to succeed. Our commitment to providing subsidized education along with good learning facilities ensures that financial barriers do not limit a child's dreams.</p>
                                <p>We focus on the holistic development of our students by nurturing academic excellence, creativity, confidence, discipline, and strong moral values. Through engaging learning experiences, sports, and co-curricular activities, we strive to prepare our students to become responsible, capable, and compassionate citizens.</p>
                                <p>I extend my heartfelt gratitude to our dedicated teachers, supportive parents, and enthusiastic students for being an integral part of our journey. Together, let us empower every child to learn, grow, and achieve their fullest potential.</p>
                                <b>Gyanendra Singh</b><br>
                                <b>Principal</b><br>
                                <b>Baburam Vedanta School, Bharatpur</b>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </section>
        <!-- teacher details widget end here-->

    </main>
</template>
<script>
export default {
    name: "LeadershipMessageView",
};
</script>
